import React, { memo, ChangeEvent } from 'react'
import DeleteIcon from 'transfix-icons/build/DeleteIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { ICarrierReference } from 'types/carrier'
import { Checkbox } from 'components/forms'
import ReferenceEntryForm from './ReferenceEntryForm'

interface IReferenceEntry {
  reference: ICarrierReference
  deleteReference: (uuid: string) => void
  updateReference: (e: { value: string; id: string }) => void
  index: number
}

const ReferenceEntry = memo<IReferenceEntry>(
  ({ deleteReference, index, reference, updateReference }) => {
    const { reviewedBy, reviewedById, uuid } = reference
    const deleteRef = () => {
      if (uuid) {
        deleteReference(uuid)
      }
    }

    const updateReferenceHandler = (e: ChangeEvent<HTMLInputElement>) => {
      const {
        target: { id: eventId, value: eventValue },
      } = e
      const event = { value: eventValue, id: eventId }
      return updateReference(event)
    }

    return (
      <div className='row' key={uuid} data-test='reference-entry'>
        <div className='col-xs-12'>
          <div className='pv4'>
            <span className='fl mb0 mt2'>References #{index + 1}</span>
            <div className='fr'>
              <IconButton
                Icon={DeleteIcon}
                color='tertiary'
                onClick={deleteRef}
                data-test='delete-reference'
                label='Edit'
                size='large'
              />
            </div>
          </div>
        </div>
        <ReferenceEntryForm
          type='edit'
          reference={reference}
          inputChange={updateReferenceHandler}
        />
        <div className='col-xs-3 mt2'>
          <div className='mt4'>
            <Checkbox
              label='Reviewed'
              name='Reviewed'
              checked={Boolean(reviewedById)}
              value={String(reviewedById)}
              onChange={updateReferenceHandler}
              disabled={Boolean(reviewedBy)}
              id={uuid}
              dataTest='update-reviewed-by'
            />
          </div>
        </div>
        <div className='col-xs-12'>
          <hr />
        </div>
      </div>
    )
  }
)

export default ReferenceEntry
